<style lang="less" scoped>
  @import "../../vars.less";

  .btn-container {
    padding: @space-normal;
  }
  .version-block {
    margin-bottom: 4px;
    padding: 20px;
    font-size: 14px;
    color: @text-color;
    background-color: #fff;
  }
  .version-title {
    font-size: 14px;
    margin: 0;
    margin-bottom: 12px;
    font-weight: 500;
  }
  .feature-list {
    margin: 0;
    font-size: 12px;
    li {
      position: relative;
      padding-left: 12px;
      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
    li:before {
      content: '';
      display: inline-block;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background-color: @text-color;
    }

  }
</style>

<template>
  <page-container
    :title="$t('版本信息')">
    <div class="version-block">
      <h3 class="version-title">版本 1.0 上线功能模块：</h3>
      <ul class="feature-list">
        <li>集成CAS登录</li>
        <li>我的客户查询申请</li>
        <li>我的订单查询</li>
        <li>客户关怀（订单加急查询申请、特殊发货查询申请）</li>
        <li>我的</li>
      </ul>
    </div>
  </page-container>
</template>

<script>
import PageContainer from '../../components/PageContainer'
import { LS_KEYS } from '../../constants'
import ls from '../../utils/local-storage'

export default {
  name: 'version-info',
  components: {
    PageContainer
  },
  data () {
    return {
      userinfo: {}
    }
  },
  methods: {
    go2changePassword () {
      this.$router.push({
        name: 'change-password',
        params: {
          stackType: 'push'
        }
      })
    }
  },
  mounted () {
    const userinfo = ls.get(LS_KEYS.USERINFO)
    if (!userinfo) {
      this.$router.push({ name: 'login' })
    } else {
      this.userinfo = userinfo
    }
  }
}
</script>
